module.exports = __webpack_public_path__ + "static/img/produto_g.d5ffbec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/laranja-zero/produto_g.png
// module id = tFyH
// module chunks = 0